const t = {
  name: "DirectDebit",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 8V16H15C17.2123 16 19 14.2123 19 12C19 9.78771 17.2123 8 15 8H5ZM13 14V10H15C16.1077 10 17 10.8923 17 12C17 13.1077 16.1077 14 15 14H13ZM7 14V10H9C10.1077 10 11 10.8923 11 12C11 13.1077 10.1077 14 9 14H7Z" fill="currentColor"/>
<path d="M0 7C0 5.34315 1.34315 4 3 4H21C22.6569 4 24 5.34315 24 7V17C24 18.6569 22.6569 20 21 20H3C1.34315 20 0 18.6569 0 17V7ZM3 6C2.44772 6 2 6.44772 2 7V17C2 17.5523 2.44772 18 3 18H21C21.5523 18 22 17.5523 22 17V7C22 6.44772 21.5523 6 21 6H3Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as DirectDebit
};
